/**
 * JS for ACF: Flexible Content > Layouts > Slider sur fond gris
 */

const sliders = document.querySelectorAll(".double-slider");

if (sliders.length > 0) {
  sliders.forEach((slider) => {
    const sliderContent = slider.querySelector(".double-slider__content");
    const sliderImage = slider.querySelector(".double-slider__image");
    const sliderContentPagination = slider.querySelector(
      ".slider-pagination--content"
    );
    const sliderImagePagination = slider.querySelector(
      ".slider-pagination--image"
    );

    const contentSwiper = new Swiper(sliderContent, {
      effect: "fade",
      autoHeight: true,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: sliderContentPagination,
        clickable: true,
      },
    });

    const imageSwiper = new Swiper(sliderImage, {
      autoHeight: true,
      pagination: {
        el: sliderImagePagination,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      },
    });

    contentSwiper.controller.control = imageSwiper;
    imageSwiper.controller.control = contentSwiper;
  });
}
